export const convertDotToComma = (value) => {
    return String(value).replace('.', ',');
}
export const convertCommaToDotNumber = (value) => {
  if (typeof value === 'string') {
    return parseFloat(value.replace(',', '.'));
  }
  if (typeof value === 'number') {
    return value;
  }
};
